import riot from 'riot';
import events from '../src/events.js';
import { getSensors as libGetSensors, postLesson as libPostLesson, putLesson as libPutLesson, postQuestion as libPostQuestion } from '../src/lib.js';
riot.tag2('lesson-build', '<nav class="navbar" role="navigation" aria-label="main navigation" if="{!submitLessonLoading}" style="background-color: rgb(245,245,245); border-bottom: 1px solid #dbdbdb;"> <div class="navbar-brand"> <span class="navbar-item"> <span class="icon has-text-info" style="margin-right: 0.4rem;"><i class="fas fa-pencil-alt"></i></span> <span class="has-text-weight-semibold">{opts.edit_mode ? \'Edit\' : \'Build\'} a {opts.build_type}</span> </span> </div> <div class="navbar-menu is-active"> <div class="navbar-end"> <div class="navbar-item"> <div class="buttons"> <button class="button is-danger" onclick="{exitBuildLessonClick}"> <span class="icon is-small"><i class="fas fa-times"></i></span> <span>Close</span> </button> </div> </div> </div> </div> </nav> <div class="container is-fluid has-text-centered" show="{submitLessonLoading}" style="margin-top: 5px;"> <span class="button is-outlined is-rounded is-large is-danger is-loading">Loading</span> </div> <div class="column is-12" if="{!submitLessonLoading && lessonsError}" style="margin-top: 5px;"> <article class="message is-danger"> <div class="message-header"> <p>Oh No!</p> <button class="delete" aria-label="delete" onclick="{closeErrorClick}"></button> </div> <div class="message-body"> It looks like there was an error submitting your {opts.build_type}! Please be sure all fields are filled out! </div> </article> </div> <div class="column is-12" if="{!submitLessonLoading && lessonsMessage}" style="margin-top: 5px;"> <article class="message is-dark"> <div class="message-header"> <p>Success!</p> <button class="delete" aria-label="delete" onclick="{closeMessageClick}"></button> </div> <div class="message-body"> {lessonsMessage} </div> </article> </div> <div class="box" show="{!submitLessonLoading}"> <nav class="pagination is-centered" role="navigation" aria-label="pagination"> <a class="pagination-previous" onclick="{prevStep}">Previous</a> <a class="pagination-next" onclick="{nextStep}">{isLastStep() ? \'Publish\':\'Next\'}</a> <a class="pagination-next" onclick="{saveDraft}" if="{isLastStep()}" style="margin-right: 0.5rem; background-color: #f5f5f5; border-color: #dbdbdb;">Save as Draft</a> <ul class="pagination-list"> <li each="{tab,i in buildSteps}" class="tab" onclick="{parent.toggleTab}"> <a class="pagination-link {is-current: parent.isActiveTab(i)}"> <span class="icon is-small"><i class="fa {tab.icon}" aria-hidden="true"></i></span> <span>Step {i+1}: {tab.title}</span> </a> </li> </ul> </nav> </div> <div class="card" show="{!submitLessonLoading}"> <header class="card-header"> <p class="card-header-title"> Step {buildStepIndex+1}: {buildSteps[buildStepIndex].title} </p> </header> <div class="card-content" show="{buildStepIndex===0}"> <div class="field" if="{opts.build_type === \'lesson\' && !opts.edit_mode}"> <label class="label">Start from Existing Lesson? (Optional)</label> <div class="control"> <div class="select is-fullwidth"> <select id="existingLessonSelect" onchange="{selectExistingLesson}"> <option value="">-- Select a lesson --</option> <option each="{l in existingLessons}" riot-value="{l.id}">{l.name}</option> </select> </div> </div> </div> <div class="field" if="{opts.build_type === \'project\' && !opts.edit_mode}"> <label class="label">Start from Existing Project? (Optional)</label> <div class="control"> <div class="select is-fullwidth"> <select id="existingProjectSelect" onchange="{selectExistingProject}"> <option value="">-- Select a project --</option> <option each="{p in existingProjects}" riot-value="{p.id}">{p.name}</option> </select> </div> </div> </div> <div class="field"> <label class="label">Title</label> <div class="control"> <input class="input" type="text" id="newLessonName" placeholder="Give your new lesson a title!"> </div> </div> <div class="field"> <label class="label">Subtitle</label> <div class="control"> <input class="input" type="text" id="newLessonFunName" placeholder="This appears as the subtitle to your lesson and should be a catchy or fun phrase to get students excited!"> </div> </div> <div class="field" if="{opts.build_type === \'lesson\'}"> <label class="label">Prep Time</label> <div class="control"> <input class="input" id="newLessonPrepTime" placeholder="How many minutes to prep?"> </div> </div> <div class="field" if="{opts.build_type === \'lesson\'}"> <label class="label">Lesson Time</label> <div class="control"> <input class="input" id="newLessonLessonTime" placeholder="How many minutes for the lesson?"> </div> </div> <div class="field" if="{opts.build_type === \'lesson\'}"> <label class="label">Focus</label> <div class="control"> <input class="input" type="text" id="newLessonFocus" placeholder="What is the main focus of this lesson?"> </div> </div> <div class="field" if="{opts.build_type === \'lesson\'}"> <label class="label">Objectives</label> <div class="field has-addons"> <div class="control is-expanded"> <input class="input" type="text" id="newLessonObjectiveInput" placeholder="Enter an objective"> </div> <div class="control"> <button class="button is-success" type="button" onclick="{addObjectiveClick}">Add Objective</button> </div> </div> <div if="{lessonObjectives.length}"> <div each="{o, i in lessonObjectives}" class="field has-addons" style="margin-bottom: 0.5rem;"> <div class="control is-expanded"> <input class="input" type="text" riot-value="{o}" oninput="{updateObjectiveInput}"> </div> <div class="control"> <button class="button is-danger" type="button" onclick="{removeObjectiveClick}"> <span class="icon is-small"> <i class="fas fa-trash"></i> </span> </button> </div> </div> </div> </div> <div class="field"> <label class="label" if="{opts.build_type === \'lesson\'}">Grade Level</label> <div class="control" if="{opts.build_type === \'lesson\'}"> <div class="select is-fullwidth"> <select id="newLessonGradeLevel"> <option value="">Select grade level</option> <option each="{g in gradeLevels}" riot-value="{g}">{g}</option> </select> </div> </div> </div> <div class="field"> <label class="label">Icon</label> <div class="control"> <div class="columns is-mobile"> <div class="column is-narrow"> <figure class="image is-48x48" style="border: 1px solid #dbdbdb; border-radius: 4px; padding: 4px;"> <img id="iconPreview" src="img/brand/Edjro_Logo_Mark_Emerald.png" alt="Icon Preview" style="object-fit: contain;"> </figure> </div> <div class="column"> <div class="select is-fullwidth"> <select id="newLessonIcon" onchange="{updateIconPreview}"> <option value="">-- Select an icon --</option> <optgroup label="Brand Icons"> <option value="brand/Filament_Logo_Mark_Emerald.png">Filament Flower (Emerald)</option> <option value="brand/Edjro_Logo_Mark_Emerald.png" selected>Edjro Labs (Emerald)</option> <option value="brand/Filament_Logo_Mark_Navy.png">Filament Flower (Navy)</option> <option value="brand/Edjro_Logo_Mark_Navy.png">Edjro Labs (Navy)</option> </optgroup> <optgroup label="Lesson Badges"> <option value="badges/lessons/plants_2.png">Plants 2</option> <option value="badges/lessons/plants_3.png">Plants 3</option> <option value="badges/lessons/plants_4.png">Plants 4</option> <option value="badges/lessons/plants_5.png">Plants 5</option> <option value="badges/lessons/ramps_3.png">Ramps 3</option> <option value="badges/lessons/ramps_4.png">Ramps 4</option> <option value="badges/lessons/ramps_5.png">Ramps 5</option> <option value="badges/lessons/roller_coaster_4.png">Roller Coaster 4</option> <option value="badges/lessons/roller_coaster_5.png">Roller Coaster 5</option> <option value="badges/lessons/roller_coaster_6.png">Roller Coaster 6</option> <option value="badges/lessons/science_of_energy.png">Science of Energy</option> <option value="badges/lessons/science_of_energy_2.png">Science of Energy 2</option> </optgroup> <optgroup label="Project Badges"> <option value="badges/projects/garden_project.png">Garden Project</option> <option value="badges/projects/greenhouse_project.png">Greenhouse Project</option> <option value="badges/projects/hydroponics_project.png">Hydroponics Project</option> <option value="badges/projects/iot_intro_project.png">IoT Intro Project</option> <option value="badges/projects/material_detective_project.png">Material Detective</option> <option value="badges/projects/seismograph_project.png">Seismograph Project</option> <option value="badges/projects/smoke_detector_project.png">Smoke Detector</option> <option value="badges/projects/test_all_sensors_project.png">Test All Sensors</option> <option value="badges/projects/weather_station_project.png">Weather Station</option> </optgroup> </select> </div> </div> </div> </div> </div> <div class="field"> <label class="label">Description</label> <div class="control"> <textarea class="textarea" id="newLessonDescription" placeholder="Give a description of your lesson! What will it teach?"></textarea> </div> </div> </div> <div class="card-content" show="{buildStepIndex===1}"> <div class="columns is-multiline"> <div class="column is-4"> <article class="message"> <div class="message-header is-success"> <p>Add Supply to Lesson</p> </div> <div class="message-body"> <div class="field"> <label class="label">Add Sensor from Kit</label> <div class="control"> <div class="select is-fullwidth"> <select id="newSupplySensorSelect" onchange="{addSensorSupply}"> <option value="">-- Select a sensor --</option> <option each="{s in sensorOptions}" riot-value="{s.name}">{s.display_name} - {s.measures}</option> </select> </div> </div> </div> <div class="has-text-centered" style="margin: 0.5em 0; font-weight: bold;">OR</div> <div id="manualSupplyFields"> <div class="field"> <label class="label">Name</label> <div class="control"> <input class="input" id="newSupplyName" type="text" placeholder="What is the supply?"> </div> </div> <div class="field"> <label class="label">Description</label> <div class="control"> <textarea class="textarea" id="newSupplyDescription" placeholder="Give an optional description of the supply!"></textarea> </div> </div> <div class="field"> <label class="label">Image (optional)</label> <div class="control"> <input class="input" id="newSupplyImage" type="text" placeholder="Image filename (e.g. sensor.png)"> </div> </div> <div class="button is-success" onclick="{addSupplyClick}">Add!</div> </div> </div> </article> </div> <div class="column is-8"> <article class="message"> <div class="message-header is-info"> <p>Supplies Needed for Lesson</p> </div> <div class="message-body"> <div class="columns is-multiline"> <div class="column is-6" each="{s in supplies}"> <div class="card" style="height: 100%;"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48" if="{s.img}"> <img riot-src="{⁗img/⁗ + s.img}" alt="{s.name}" style="object-fit: contain; padding: 0.25rem;"> </figure> <figure class="image is-48x48" if="{!s.img}"> <img src="img/brand/Edjro_Logo_Mark_Emerald.png" alt="{s.name}" style="object-fit: contain; padding: 0.25rem;"> </figure> </div> <div class="media-content"> <p class="title is-5">{s.name}</p> </div> <div class="media-right"> <button class="button is-danger is-small" onclick="{removeSupplyClick}"> <span class="icon is-small"> <i class="fas fa-trash"></i> </span> </button> </div> </div> <div class="content"> <p>{s.description}</p> </div> </div> </div> </div> </div> </div> </article> </div> </div> </div> <div class="card-content" show="{buildStepIndex===2}"> <div class="columns is-multiline"> <div class="column is-2"> <article class="message"> <div class="message-header is-success"> <p>Link to another State Standard</p> </div> <div class="message-body"> <div class="field"> <label class="label">Name</label> <div class="control"> <input class="input" id="newStandardName" type="text" placeholder="What is the state standard you would like to link?"> </div> </div> <div class="field"> <label class="label">Description</label> <div class="control"> <textarea class="textarea" id="newStandardDescription" placeholder="Give an optional description of the state standard!"></textarea> </div> </div> <div class="button is-success" onclick="{addStandardClick}">Add!</div> </div> </article> </div> <div class="column is-2" each="{s in stateStandards}"> <article class="message"> <div class="message-header"> <input class="input" type="text" riot-value="{s.name}" oninput="{updateStandardName}" style="background: transparent; border: none; color: white; padding: 0; font-weight: 700;"> <button class="delete" onclick="{removeStandardClick}"></button> </div> <div class="message-body"> <textarea class="textarea" oninput="{updateStandardDescription}" style="min-height: 80px;">{s.description}</textarea> </div> </article> </div> </div> </div> <div class="card-content" show="{buildStepIndex===3}"> <div class="columns"> <div class="column is-4"> <article class="panel"> <p class="panel-heading"> Steps in {opts.build_type} </p> <p class="panel-tabs"> <a class="{is-active: stepFilterType === \'all\'}" data-filter="all" onclick="{stepFilterTabClick}">All</a> <a class="{is-active: stepFilterType === \'setup\'}" data-filter="setup" onclick="{stepFilterTabClick}">Setup</a> <a class="{is-active: stepFilterType === \'task\'}" data-filter="task" onclick="{stepFilterTabClick}">Tasks</a> <a class="{is-active: stepFilterType === \'quiz\'}" data-filter="quiz" onclick="{stepFilterTabClick}">Knowledge Checks</a> </p> <div class="notification is-warning is-light" style="margin:0.5rem; padding:0.5rem 0.75rem; font-size:0.85em;" if="{opts.edit_mode && opts.has_active_activities}"> <strong>Lesson in progress</strong> — Adding or reordering steps is disabled while there are active sessions. </div> <a class="panel-block" onclick="{selectNewStepClick}" riot-style="{opts.edit_mode && opts.has_active_activities ? \'opacity:0.4; pointer-events:none; cursor:not-allowed;\' : \'\'}"> <span class="panel-icon"> <i class="fas fa-plus" aria-hidden="true"></i> </span> Add Another Step </a> <div class="panel-block {selectedNewStep === i?\'is-active\':\'\'}" each="{ls,i in getFilteredSteps()}" style="display:flex; align-items:center; gap:0.4rem; padding: 0.5em 0.75em;"> <span class="panel-icon" style="flex-shrink:0;"> <i class="fas fa-book" aria-hidden="true"></i> </span> <span style="flex:1; cursor:pointer;" onclick="{selectNewStepClick}">{ls.title} {selectedNewStep === i?\'(Editing)\':\'\'}</span> <span class="buttons has-addons" style="flex-shrink:0; margin-bottom:0;" if="{stepFilterType===\'all\' && !(opts.edit_mode && opts.has_active_activities)}"> <button class="button is-small" title="Move up" onclick="{moveStepUpClick}" disabled="{lessonSteps.indexOf(ls) === 0}"> <span class="icon is-small"><i class="fas fa-arrow-up"></i></span> </button> <button class="button is-small" title="Move down" onclick="{moveStepDownClick}" disabled="{lessonSteps.indexOf(ls) === lessonSteps.length - 1}"> <span class="icon is-small"><i class="fas fa-arrow-down"></i></span> </button> </span> </div> </article> </div> <div class="column is-8"> <article class="message" if="{selectedNewStep===- 1}"> <div class="message-header is-success"> <p><strong>Add Another Step</strong></p> </div> <div class="message-body"> <div class="columns is-multiline"> <div class="column is-12"> <div class="field"> <label class="label">Title</label> <div class="control"> <input class="input" type="text" id="newStepTitle" placeholder="Give your new step a title!"> </div> </div> <div class="field"> <label class="label">Directions</label> <div class="control"> <textarea class="textarea" id="newStepDirections" placeholder="Give the directions for your lesson step! These should tell the student how to perfrom this step of the lesson. If there are multiple steps in the directions, separate them with periouds (in sentences)."></textarea> </div> </div> <div class="field"> <label class="label">Image</label> <div class="control"> <input class="input" type="text" id="newStepImage" placeholder="Use an image for this step!"> </div> </div> </div> <div class="column is-12"> <label class="label">Step Type</label> <div class="field has-addons"> <p class="control"> <button class="button {newStepType==\'setup\'?\'is-dark\':\'\'}" onclick="{newStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-file-alt"></i> </span> <span>Setup</span> </button> </p> <p class="control"> <button class="button {newStepType==\'task\'?\'is-dark\':\'\'}" onclick="{newStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-microchip"></i> </span> <span>Task</span> </button> </p> <p class="control"> <button class="button {newStepType==\'quiz\'?\'is-dark\':\'\'}" onclick="{newStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-question"></i> </span> <span>Quiz</span> </button> </p> </div> <div class="box" if="{newStepType===\'setup\'}"> <h3>No Additional Information Needed</h3> </div> <div class="box" if="{newStepType===\'task\'}"> <h3>Select The Sensor</h3> <div class="control has-icons-left"> <div class="select"> <select id="newStepMeasureToggle"> <option each="{s in sensorOptions}">{s.display_name}</option> </select> </div> <span class="icon is-left"> <i class="fas fa-microchip"></i> </span> </div> </div> <div class="box" if="{newStepType===\'quiz\'}"> <div if="{newStepQuestions.length > 0}"> <p class="label is-small has-text-grey" style="margin-bottom: 0.5rem;">Questions added</p> <div each="{q in newStepQuestions}" style="margin-bottom: 10px;"> <div class="field has-addons has-addons-centered"> <p class="control"> <a class="button is-light is-small">{questionTypeToDisplay(q.type)}</a> </p> <p class="control is-expanded"> <input class="input is-small" type="text" riot-value="{q.question}"> </p> <p class="control"> <a class="button is-danger is-small" onclick="{deleteNewStepQuestionClick}"> <span class="icon is-small"><i class="fas fa-trash-alt"></i></span> </a> </p> </div> <div class="box" if="{q.type===\'mc\'}" style="box-shadow: none; padding: 0.5rem;"> <div class="columns is-mobile is-multiline"> <div class="column is-6" each="{opt, oi in q.options}"> <span class="tag is-medium" style="margin-bottom: 5px;">{opt}</span> </div> </div> </div> </div> <hr style="margin: 0.75rem 0;"> </div> <p class="label is-small has-text-grey" style="margin-bottom: 0.4rem;">Add a question</p> <div class="field has-addons"> <p class="control"> <span class="select"> <select id="newStepQuestionTypeToggle" onchange="{quizNewQuestionTypeChange}"> <option>Free Answer</option> <option>True / False</option> <option>Multiple Choice</option> </select> </span> </p> <p class="control is-expanded"> <input class="input" type="text" placeholder="Type your question here" id="newStepQuestion"> </p> <p class="control"> <a class="button is-info" onclick="{addNewStepQuestionClick}"> <span class="icon is-small"><i class="fas fa-plus"></i></span> <span>Add Question</span> </a> </p> </div> <p class="help" style="margin-top: 0.25rem;">Click <strong>Add Question</strong> for each question. All added questions will be saved when you click <em>Add This Step</em> below.</p> <div class="box" if="{newStepQuestionType===\'Multiple Choice\'}"> <h4 class="title is-5">Answer Options</h4> <div class="columns is-mobile is-multiline"> <div class="column is-6" each="{opt, oi in newStepMCAnswers}"> <input class="input mc-answer-input" type="text" riot-value="{opt}"> </div> </div> </div> </div> </div> </div> <div class="button is-success" onclick="{addLessonStepClick}">Add This {opts.build_type} Step</div> <div class="notification is-success is-light" if="{showAddedLessonStepNotification}"> <button class="delete" onclick="{closeAddedLessonStepNotificationClick}"></button> Successfully added the new step to your {opts.build_type}! </div> </div> </article> <article class="message" if="{selectedNewStep !=- 1}"> <div class="message-header is-info"> <p>{lessonSteps[selectedNewStep].title} (Editing)</p> </div> <div class="message-body"> <div class="columns is-multiline"> <div class="column is-12"> <div class="field"> <label class="label">Step Title</label> <div class="control"> <input class="input" type="text" id="selectedStepTitle" placeholder="Give your new step a short title!"> </div> </div> <div class="field"> <label class="label">Step Directions</label> <div class="control"> <textarea class="textarea" id="selectedStepDirections" placeholder="Give the directions for your lesson step! These should tell the student how to perfrom this step of the lesson. If there are multiple steps in the directions, separate them with periouds (in sentences)."></textarea> </div> </div> <div class="field"> <label class="label">Step Image</label> <div class="control"> <input class="input" type="text" id="selectedStepImage" placeholder="Use an image for this step!"> </div> </div> </div> <div class="column is-12"> <label class="label">Step Type</label> <div class="field has-addons"> <p class="control"> <button class="button {selectedStepToEdit.type==\'setup\'?\'is-dark\':\'\'}" onclick="{selectedStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-file-alt"></i> </span> <span>Setup</span> </button> </p> <p class="control"> <button class="button {selectedStepToEdit.type==\'task\'?\'is-dark\':\'\'}" onclick="{selectedStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-microchip"></i> </span> <span>Task</span> </button> </p> <p class="control"> <button class="button {selectedStepToEdit.type==\'quiz\'?\'is-dark\':\'\'}" onclick="{selectedStepTypeClick}"> <span class="icon is-small"> <i class="fas fa-question"></i> </span> <span>Quiz</span> </button> </p> </div> <div class="box" if="{selectedStepToEdit.type===\'setup\'}"> <h3>No Additional Information Needed</h3> </div> <div class="box" if="{selectedStepToEdit.type===\'task\'}"> <h3>Select Sensor to Use!</h3> <div class="control has-icons-left"> <div class="select"> <select id="selectedStepMeasureToggle"> <option each="{s in sensorOptions}">{s.display_name}</option> </select> </div> <span class="icon is-left"> <i class="fas fa-microchip"></i> </span> </div> </div> <div class="box" if="{selectedStepToEdit.type===\'quiz\'}"> <div if="{selectedStepToEdit.questions && selectedStepToEdit.questions.length > 0}"> <p class="label is-small has-text-grey" style="margin-bottom: 0.5rem;">Questions added</p> <div each="{q,qi in selectedStepToEdit.questions}" style="margin-bottom: 10px;"> <div class="field has-addons has-addons-centered"> <p class="control"> <a class="button is-light is-small">{questionTypeToDisplay(q.type)}</a> </p> <p class="control is-expanded"> <input class="input is-small" type="text" riot-value="{q.question}"> </p> <p class="control"> <a class="button is-danger is-small" onclick="{deleteSelectedStepQuestionClick}"> <span class="icon is-small"><i class="fas fa-trash-alt"></i></span> </a> </p> </div> <div class="box" if="{q.type===\'mc\'}" style="box-shadow: none; padding: 0.5rem;"> <div class="columns is-mobile is-multiline"> <div class="column is-6" each="{opt, oi in q.options}"> <span class="tag is-medium" style="margin-bottom: 5px;">{opt}</span> </div> </div> </div> </div> <hr style="margin: 0.75rem 0;"> </div> <p class="label is-small has-text-grey" style="margin-bottom: 0.4rem;">Add a question</p> <div class="field has-addons"> <p class="control"> <span class="select"> <select id="selectedStepQuestionTypeToggle" onchange="{quizSelectedQuestionTypeChange}"> <option>Free Answer</option> <option>True / False</option> <option>Multiple Choice</option> </select> </span> </p> <p class="control is-expanded"> <input class="input" type="text" placeholder="Type your question here" id="selectedStepQuestion"> </p> <p class="control"> <a class="button is-info" onclick="{addSelectedStepQuestionClick}"> <span class="icon is-small"><i class="fas fa-plus"></i></span> <span>Add Question</span> </a> </p> </div> <div class="box" if="{selectedStepQuestionType===\'Multiple Choice\'}"> <h4 class="title is-5">Answer Options</h4> <div class="columns is-mobile is-multiline"> <div class="column is-6" each="{opt, oi in selectedStepMCAnswers}"> <input class="input mc-selected-answer-input" type="text" riot-value="{opt}"> </div> </div> </div> </div> </div> </div> <div class="button is-warning" onclick="{saveSelectedLessonStepClick}">Save This {opts.build_type} Step</div> <div class="button is-danger" onclick="{deleteSelectedLessonStepClick}">Delete This {opts.build_type} Step</div> </div> </article> </div> </div> </div> <footer class="card-footer"> <a class="card-footer-item" onclick="{prevStep}"><span class="subtitle"><span class="icon is-small"> <i class="fas fa-arrow-left"></i> </span>&nbsp;Previous Step</span></a> <a class="card-footer-item" onclick="{exitBuildLessonClick}"><span class="subtitle"><span class="icon is-small"> <i class="fas fa-times"></i> </span>&nbsp;Cancel</span></a> <a class="card-footer-item" onclick="{saveDraft}" if="{isLastStep()}"><span class="subtitle"><span class="icon is-small"> <i class="fas fa-save"></i> </span>&nbsp;Save as Draft</span></a> <a class="card-footer-item" onclick="{nextStep}"><span class="subtitle">{isLastStep() ? \'Publish \' + opts.build_type : \'Next Step\'}&nbsp;<span class="icon is-small"> <i class="fas {isLastStep() ? \'fa-check\' : \'fa-arrow-right\'}"></i> </span></span></a> </footer> </div>', '', '', function(opts) {
        var self = this;

        self.submitLessonLoading = false;

        self.buildSteps = [{
            "title": "Build Basic Data",
            "description": "Add the basic information for the " + this.opts.build_type + "!"
        }, {
            "title": "Build Supply List",
            "description": "List all the supplies needed to complete the " + this.opts.build_type
        }, {
            "title": "Link State Standards",
            "description": "Optionally link your " + this.opts.build_type + " with the covered state education standards."
        }, {
            "title": "Build Steps",
            "description": "Add all the steps required to complete the " + this.opts.build_type
        }];

        self.lessonObjectives = [];

        self.addObjectiveClick = function(e) {
            var input = document.getElementById("newLessonObjectiveInput");
            var value = input.value.trim();
            if (value) {
                self.lessonObjectives.push(value);
                input.value = "";
                self.update();
            }
        };

        self.removeObjectiveClick = function(e) {
            if (e.item && e.item.i !== undefined) {
                self.lessonObjectives.splice(e.item.i, 1);
                self.update();
            }
        };

        self.updateObjectiveInput = function(e) {
            if (e.item && e.item.i !== undefined) {
                self.lessonObjectives[e.item.i] = e.target.value;
                self.update();
            }
        };

        self.updateIconPreview = function(e) {
            var selectedIcon = e.target.value;
            var previewImg = document.getElementById('iconPreview');
            if (selectedIcon && previewImg) {
                previewImg.src = 'img/' + selectedIcon;
            }
        };

        self.existingLessons = [];
        if (window.appData.lessons && Array.isArray(window.appData.lessons)) {
            self.existingLessons = window.appData.lessons;
        } else {
            var cachedLessons = localStorage.getItem("lessons");
            if (cachedLessons) {
                try {
                    self.existingLessons = JSON.parse(cachedLessons);
                } catch (e) {
                    self.existingLessons = [];
                }
            }
        }

        self.existingProjects = [];
        if (window.appData.projects && Array.isArray(window.appData.projects)) {
            self.existingProjects = window.appData.projects;
        } else {
            var cachedProjects = localStorage.getItem("projects");
            if (cachedProjects) {
                try {
                    self.existingProjects = JSON.parse(cachedProjects);
                } catch (e) {
                    self.existingProjects = [];
                }
            }
        }

        events.on('projects_loaded', function(projects) {
            if (Array.isArray(projects)) {
                self.existingProjects = projects;
                self.update();
            }
        });

        self.gradeLevels = [];
        for (var i = 1; i <= 12; i++) {
            self.gradeLevels.push(i);
        }

        events.on('lessons_loaded', function(lessons) {
            if (Array.isArray(lessons)) {
                self.existingLessons = lessons;
                self.update();
            }
        });

        self.buildStepIndex = 0;

        self.supplies = [{
            "name": "Edjro Filament",
            "in_kit": true,
            "img": "brand/Filament_Logo_Mark_Navy.png",
            "description": "You will need your Filament for this " + this.opts.build_type
        }];

        self.sensorOptions = []

        self.stateStandards = [];

        self.lessonSteps = [];

        self.selectedNewStep = -1;

        self.newStepType = 'setup';

        self.newStepQuestions = [];

        self.selectedStepQuestionType = 'Free';
        self.mcAnswers = [''];
        self.newStepMCAnswers = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];

        self.stepFilterType = 'all';

        self.showAddedLessonStepNotification = false;

        self.getFilteredSteps = function() {
            if (self.stepFilterType === 'all') {
                return self.lessonSteps;
            }
            return self.lessonSteps.filter(function(step) {
                return step.type === self.stepFilterType;
            });
        };

        self.stepFilterTabClick = function(e) {
            var filterType = e.target.getAttribute('data-filter');
            if (filterType) {
                self.stepFilterType = filterType;
                self.update();
            }
        };

        self.moveStepUpClick = function(e) {
            e.stopPropagation();
            if (self.opts.edit_mode && self.opts.has_active_activities) return;
            var step = e.item.ls;
            var idx = self.lessonSteps.indexOf(step);
            if (idx <= 0) return;
            self.lessonSteps.splice(idx, 1);
            self.lessonSteps.splice(idx - 1, 0, step);

            if (self.selectedNewStep === idx) self.selectedNewStep = idx - 1;
            self.update();
        };

        self.moveStepDownClick = function(e) {
            e.stopPropagation();
            if (self.opts.edit_mode && self.opts.has_active_activities) return;
            var step = e.item.ls;
            var idx = self.lessonSteps.indexOf(step);
            if (idx < 0 || idx >= self.lessonSteps.length - 1) return;
            self.lessonSteps.splice(idx, 1);
            self.lessonSteps.splice(idx + 1, 0, step);

            if (self.selectedNewStep === idx) self.selectedNewStep = idx + 1;
            self.update();
        };

        self.questionTypeToShort = function(displayType) {
            var map = {
                'Multiple Choice': 'mc',
                'Free Answer': 'fa',
                'True / False': 'tf'
            };
            return map[displayType] || displayType;
        };

        self.questionTypeToDisplay = function(shortType) {
            var map = {
                'mc': 'Multiple Choice',
                'fa': 'Free Answer',
                'tf': 'True / False'
            };
            return map[shortType] || shortType;
        };

        self.quizNewQuestionTypeChange = function(e) {
            var sel = document.getElementById('newStepQuestionTypeToggle');
            var newType = sel ? sel.value : 'Free Answer';
            console.log("New Question Type Selected: " + newType);
            if (newType === 'Multiple Choice') {
                if (!self.newStepMCAnswers || self.newStepMCAnswers.length < 2) {
                    self.newStepMCAnswers = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
                }
            }
            self.newStepQuestionType = newType;
            self.update();
        };

        self.quizSelectedQuestionTypeChange = function(e) {
            var sel = document.getElementById('selectedStepQuestionTypeToggle');
            var newType = sel ? sel.value : 'Free Answer';
            console.log("Selected Step Question Type Selected: " + newType);
            if (newType === 'Multiple Choice') {
                if (!self.selectedStepMCAnswers || self.selectedStepMCAnswers.length < 2) {
                    self.selectedStepMCAnswers = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
                }
            }
            self.selectedStepQuestionType = newType;
            self.update();
        };

        self.on('mount', function() {
            getSensors();

            if (self.opts.edit_mode && self.opts.lesson_to_edit) {
                self.loadLessonForEdit(self.opts.lesson_to_edit);
            }
        });

        self.loadLessonForEdit = function(lesson) {
            setTimeout(function() {

                document.getElementById("newLessonName").value = lesson.name || "";
                document.getElementById("newLessonFunName").value = lesson.fun || "";
                document.getElementById("newLessonDescription").value = lesson.description || "";
                document.getElementById("newLessonIcon").value = lesson.icon || "";

                var previewImg = document.getElementById('iconPreview');
                if (lesson.icon && previewImg) {
                    previewImg.src = 'img/' + lesson.icon;
                }

                if (self.opts.build_type === 'lesson') {
                    document.getElementById("newLessonGradeLevel").value = lesson.grade_level || "";
                    document.getElementById("newLessonPrepTime").value = lesson.prep_time || "";
                    document.getElementById("newLessonLessonTime").value = lesson.lesson_time || "";
                    document.getElementById("newLessonFocus").value = lesson.focus || "";
                    self.lessonObjectives = Array.isArray(lesson.objectives) ? lesson.objectives.slice() : (lesson.objectives ? [lesson.objectives] : []);
                }

                self.lessonSteps = lesson.steps ? JSON.parse(JSON.stringify(lesson.steps)) : [];
                self.supplies = lesson.supplies ? JSON.parse(JSON.stringify(lesson.supplies)) : [{
                    "name": "Edjro Filament",
                    "in_kit": true,
                    "img": "brand/Filament_Logo_Mark_Navy.png",
                    "description": "You will need your Filament for this " + self.opts.build_type
                }];
                self.stateStandards = lesson.standards ? JSON.parse(JSON.stringify(lesson.standards)) : [];

                self.update();
            }, 100);
        };

        self.selectExistingLesson = function(e) {
                var selectedId = e.target.value;
                if (!selectedId) return;
                var lesson = self.existingLessons.find(function(l) { return l.id == selectedId; });
                if (!lesson) return;

                document.getElementById("newLessonName").value = lesson.name || "";
                document.getElementById("newLessonFunName").value = lesson.fun || "";
                document.getElementById("newLessonDescription").value = lesson.description || "";

                document.getElementById("newLessonIcon").value = lesson.icon || "";

                var previewImg = document.getElementById('iconPreview');
                if (previewImg && lesson.icon) {
                    previewImg.src = 'img/' + lesson.icon;
                }

                if (self.opts.build_type === 'lesson') {
                    document.getElementById("newLessonGradeLevel").value = lesson.grade_level || "";
                    document.getElementById("newLessonPrepTime").value = lesson.prep_time || "";
                    document.getElementById("newLessonLessonTime").value = lesson.lesson_time || "";
                    document.getElementById("newLessonFocus").value = lesson.focus || "";
                    self.lessonObjectives = Array.isArray(lesson.objectives) ? lesson.objectives.slice() : (lesson.objectives ? [lesson.objectives] : []);
                }

                self.lessonSteps = lesson.steps ? JSON.parse(JSON.stringify(lesson.steps)) : [];
                self.supplies = lesson.supplies ? JSON.parse(JSON.stringify(lesson.supplies)) : [];
                self.stateStandards = lesson.standards ? JSON.parse(JSON.stringify(lesson.standards)) : [];
                self.update();
            }

        self.selectExistingProject = function(e) {
                var selectedId = e.target.value;
                if (!selectedId) return;
                var project = self.existingProjects.find(function(p) { return p.id == selectedId; });
                if (!project) return;

                document.getElementById("newLessonName").value = project.name || "";
                document.getElementById("newLessonFunName").value = project.fun || "";
                document.getElementById("newLessonDescription").value = project.description || "";
                document.getElementById("newLessonIcon").value = project.icon || "";

                var previewImg = document.getElementById('iconPreview');
                if (previewImg && project.icon) {
                    previewImg.src = 'img/' + project.icon;
                }

                self.lessonSteps = project.steps ? JSON.parse(JSON.stringify(project.steps)) : [];
                self.supplies = project.supplies ? JSON.parse(JSON.stringify(project.supplies)) : [];

                self.stateStandards = [];
                self.lessonObjectives = [];
                self.update();
            }

        self.exitBuildLessonClick = function(e) {
                if (this.opts.build_type == "lesson") {
                    self.parent.exitBuildLesson();
                } else {
                    self.parent.exitBuildProject();
                }
            }

        self.isActiveTab = function(tabIndex) {
                return self.buildStepIndex === tabIndex;
            }

        self.closeErrorClick = function(e) {
                self.lessonsError = "";
                self.update();
            }

        self.closeMessageClick = function(e) {
                self.lessonsMessage = "";
                self.update();
            }

        self.toggleTab = function(e) {

                self.buildStepIndex = e.item.i;
                return true;
            }

        self.isLastStep = function() {
                if (self.buildStepIndex === self.buildSteps.length - 1) {
                    return true;
                } else {
                    return false;
                }
            }

        self.nextStep = function() {

                if (self.isLastStep()) {
                    console.log(self.opts.edit_mode ? "UPDATE THE FOLLOWING LESSON" : "SUBMIT THE FOLLOWING LESSON");

                    var newLesson = self.buildLessonObject();
                    if (!newLesson) return;
                    newLesson.status = 'published';

                    console.log(newLesson);

                    if (self.opts.edit_mode) {
                        putLesson({
                            "lesson": newLesson
                        });
                    } else {
                        postLesson({
                            "lesson": newLesson
                        });
                    }

                } else {
                    self.buildStepIndex = self.buildStepIndex + 1;
                }
            }

        self.saveDraft = function() {
                var newLesson = self.buildLessonObject();
                if (!newLesson) return;
                newLesson.status = 'draft';

                console.log("SAVING DRAFT:", newLesson);

                if (self.opts.edit_mode) {
                    putLesson({ "lesson": newLesson });
                } else {
                    postLesson({ "lesson": newLesson });
                }
            }

        self.buildLessonObject = function() {
                    var newLesson = {};

                    if (self.opts.edit_mode && self.opts.lesson_to_edit) {
                        newLesson.id = self.opts.lesson_to_edit.id;
                    }

                    newLesson.name = document.getElementById("newLessonName").value;
                    newLesson.fun = document.getElementById("newLessonFunName").value;
                    newLesson.description = document.getElementById("newLessonDescription").value;

                    var iconInput = document.getElementById("newLessonIcon").value;
                    var profileData = localStorage.getItem('profile');
                    var profile = profileData && profileData !== "undefined" ? JSON.parse(profileData) : null;
                    var googleIcon = profile && profile.picture ? profile.picture : "";
                    newLesson.icon = iconInput || googleIcon;
                    if (self.opts.build_type === 'lesson') {
                        var gradeLevelRaw = document.getElementById("newLessonGradeLevel").value.trim();
                        var gradeLevelInt = parseInt(gradeLevelRaw, 10);
                        if (!isNaN(gradeLevelInt) && gradeLevelInt >= 1 && gradeLevelInt <= 12) {
                            newLesson.grade_level = gradeLevelInt;
                        } else {
                            newLesson.grade_level = "";
                        }
                        newLesson.prep_time = document.getElementById("newLessonPrepTime").value || "";
                        newLesson.lesson_time = document.getElementById("newLessonLessonTime").value || "";
                        newLesson.focus = document.getElementById("newLessonFocus").value || "";
                        newLesson.objectives = self.lessonObjectives.slice();
                    }
                    newLesson.type = self.opts.build_type;

                    var profileData = localStorage.getItem('profile');
                    if (!profileData || profileData === "undefined") {
                        console.error("Profile not loaded yet, cannot create lesson");
                        return null;
                    }
                    var profile = JSON.parse(profileData);

                    newLesson.author = {
                        "id": profile.user_id,
                        "first_name": profile.first_name,
                        "last_name": profile.last_name
                    };
                    newLesson.supplies = self.supplies;
                    newLesson.steps = self.lessonSteps;
                    console.log(self.lessonSteps);
                    newLesson.standards = self.stateStandards;

                    return newLesson;
            }

        self.prevStep = function() {

                if (self.buildStepIndex === 0) {
                    return
                } else {
                    self.buildStepIndex = self.buildStepIndex - 1;
                }
            }

        self.newStepTypeClick = function(e) {
                self.newStepType = e.target.innerText.toLowerCase();

                if (self.selectedNewStep !== -1 && self.selectedStepToEdit) {
                    self.selectedStepToEdit.type = self.newStepType;
                }
                self.update();
            }

        self.selectedStepTypeClick = function(e) {
                self.selectedStepToEdit.type = e.target.innerText.toLowerCase();
                self.update();
            }

        self.convertBetweenSensorNameAndPrettyName = function(sensorName, toPretty) {
                for (var i = 0; i < self.sensorOptions.length; i++) {
                    if (toPretty) {
                        if (self.sensorOptions[i].name === sensorName) {
                            return self.sensorOptions[i].display_name;
                        }
                    } else {
                        if (self.sensorOptions[i].display_name === sensorName) {
                            return self.sensorOptions[i].name;
                        }
                    }
                }
                return sensorName;
            }

        self.selectNewStepClick = function(e) {
                if (self.opts.edit_mode && self.opts.has_active_activities && !e.item) return;
                if (!e.item) {
                    self.selectedNewStep = -1;
                    self.newStepType = 'setup';
                    self.update();
                } else {
                    self.selectedNewStep = e.item.i;
                    self.selectedStepToEdit = e.item.ls;

                    self.newStepType = (self.selectedStepToEdit.type || 'setup').toLowerCase();
                    self.update();
                    setTimeout(function() {
                        document.getElementById("selectedStepTitle").value = self.selectedStepToEdit.title;
                        document.getElementById("selectedStepDirections").value = self.selectedStepToEdit.directions;
                        document.getElementById("selectedStepImage").value = self.selectedStepToEdit.image || "";
                        if (self.selectedStepToEdit.type && self.selectedStepToEdit.type.toLowerCase() === 'task') {
                            var selectSensor = document.getElementById("selectedStepMeasureToggle");

                            for (var i = 0; i < selectSensor.options.length; i++) {
                                var sensorDisplayName = self.convertBetweenSensorNameAndPrettyName(self.selectedStepToEdit.sensor, true);
                                if (selectSensor.options[i].value == sensorDisplayName) {
                                    selectSensor.selectedIndex = i;
                                }
                            }
                        }
                    }, 0);
                }
            }

        self.addSupplyClick = function(e) {
            var newSupply = {
                id: self.supplies.length + 1,
                name: document.getElementById("newSupplyName").value,
                description: document.getElementById("newSupplyDescription").value,
                img: document.getElementById("newSupplyImage").value || "",
                in_kit: false
            };
            self.supplies.push(newSupply);

            document.getElementById("newSupplyName").value = "";
            document.getElementById("newSupplyDescription").value = "";
            document.getElementById("newSupplyImage").value = "";
            self.update();
        }

        self.addSensorSupply = function(e) {
            var sensorVal = e.target.value;
            var manualFields = document.getElementById("manualSupplyFields");
            if (sensorVal) {

                if (manualFields) manualFields.style.display = "none";

                var sensorObj = self.sensorOptions.find(function(s) { return s.name == sensorVal; });
                if (sensorObj) {
                    var newSupply = {
                        id: self.supplies.length + 1,
                        type: "sensor",
                        name: sensorObj.name,
                        description: sensorObj.description || "Sensor from kit.",
                        img: sensorObj.image || "",
                        in_kit: true
                    };
                    self.supplies.push(newSupply);

                    e.target.selectedIndex = 0;
                    if (manualFields) manualFields.style.display = "";
                    self.update();
                }
            } else {

                if (manualFields) manualFields.style.display = "";
            }
        }

        self.removeSupplyClick = function(e) {
            var supplyToRemove = e.item.s;
            for (var i = 0; i < self.supplies.length; i++) {
                if (self.supplies[i] === supplyToRemove) {
                    self.supplies.splice(i, 1);
                    break;
                }
            }
            self.update();
        }

        self.addStandardClick = function(e) {
            var newStandard = {
                "name": document.getElementById("newStandardName").value,
                "description": document.getElementById("newStandardDescription").value
            }
            self.stateStandards.push(newStandard);
            document.getElementById("newStandardName").value = "";
            document.getElementById("newStandardDescription").value = "";
            self.update();
        }

        self.removeStandardClick = function(e) {
            var standardToRemove = e.item.s;
            for (var i = 0; i < self.stateStandards.length; i++) {
                if (self.stateStandards[i] === standardToRemove) {
                    self.stateStandards.splice(i, 1);
                    break;
                }
            }
            self.update();
        }

        self.updateStandardName = function(e) {
            if (e.item && e.item.s) {
                e.item.s.name = e.target.value;
                self.update();
            }
        }

        self.updateStandardDescription = function(e) {
            if (e.item && e.item.s) {
                e.item.s.description = e.target.value;
                self.update();
            }
        }

        self.addNewStepQuestionClick = function(e) {
            var qTypeSel = document.getElementById("newStepQuestionTypeToggle");
            var newStepQuestionType = qTypeSel.options[qTypeSel.selectedIndex].value;
            var questionText = document.getElementById("newStepQuestion").value;
            if (newStepQuestionType === "Multiple Choice") {

                var answerInputs = document.querySelectorAll('.mc-answer-input');
                var optionsList = [];
                answerInputs.forEach(function(input) {
                    var val = input.value.trim();
                    if (val) {
                        optionsList.push(val);
                    }
                });

                self.newStepQuestions.push({
                    "id": self.newStepQuestions.length,
                    "question": questionText,
                    "type": self.questionTypeToShort(newStepQuestionType),
                    "options": optionsList
                });

                self.newStepMCAnswers = ["Option 1", "Option 2", "Option 3", "Option 4"];
            } else {

                self.newStepQuestions.push({
                    "id": self.newStepQuestions.length,
                    "question": questionText,
                    "type": self.questionTypeToShort(newStepQuestionType)
                });
            }
            document.getElementById("newStepQuestion").value = "";
        }

        self.deleteNewStepQuestionClick = function(e) {

            if(e.item.q === undefined){
                return;
            }
            for (var i = 0; i < self.newStepQuestions.length; i++) {
                if (self.newStepQuestions[i].id === e.item.q.id) {
                    self.newStepQuestions.splice(i, 1);
                }
            }
        }

        self.addSelectedStepQuestionClick = function(e) {
            var qTypeSel = document.getElementById("selectedStepQuestionTypeToggle");
            var selectedStepQuestionType = qTypeSel.options[qTypeSel.selectedIndex].value;
            var questionText = document.getElementById("selectedStepQuestion").value;
            if (selectedStepQuestionType === 'Multiple Choice') {

                var answerInputs = document.querySelectorAll('.mc-selected-answer-input');
                var optionsList = [];
                answerInputs.forEach(function(input) {
                    var val = input.value.trim();
                    if (val) {
                        optionsList.push(val);
                    }
                });
                self.selectedStepToEdit.questions.push({
                    "id": self.selectedStepToEdit.questions.length,
                    "question": questionText,
                    "type": self.questionTypeToShort(selectedStepQuestionType),
                    "options": optionsList
                });
                self.selectedStepMCAnswers = [''];
            } else {
                self.selectedStepToEdit.questions.push({
                    "id": self.selectedStepToEdit.questions.length,
                    "question": questionText,
                    "type": self.questionTypeToShort(selectedStepQuestionType)
                });
            }
            document.getElementById("selectedStepQuestion").value = "";
            self.selectedStepQuestionType = 'Free';
            self.update();
        }

        self.deleteSelectedStepQuestionClick = function(e) {

            if(e.item.q === undefined){
                return;
            }
            for (var i = 0; i < self.selectedStepToEdit.questions.length; i++) {
                if (self.selectedStepToEdit.questions[i].id === e.item.q.id) {
                    self.selectedStepToEdit.questions.splice(i, 1);
                }
            }
        }

        self.saveAndCloseClick = function(e) {

            return
        }

        self.addLessonStepClick = function(e) {
            var newLessonStep = {};
            newLessonStep.title = document.getElementById("newStepTitle").value;
            newLessonStep.directions = document.getElementById("newStepDirections").value;
            newLessonStep.type = self.newStepType;
            if (document.getElementById("newStepImage").value) {
                newLessonStep.image = document.getElementById("newStepImage").value;
            }

            if (self.newStepType === 'task') {

                var measureSel = document.getElementById("newStepMeasureToggle");
                var newStepMeasure = measureSel.options[measureSel.selectedIndex].value;

                newLessonStep.sensor = self.convertBetweenSensorNameAndPrettyName(newStepMeasure, false);
            }

            if (self.newStepType === 'quiz') {

                var pendingNewQuestion = document.getElementById('newStepQuestion');
                if (pendingNewQuestion && pendingNewQuestion.value.trim()) {
                    self.addNewStepQuestionClick({});
                }
                newLessonStep.questions = self.newStepQuestions;
            }

            self.lessonSteps.push(newLessonStep)

            document.getElementById("newStepTitle").value = "";
            document.getElementById("newStepDirections").value = "";
            document.getElementById("newStepImage").value = "";
            self.newStepType = "setup";
            self.newStepQuestions = [];

            self.showAddedLessonStepNotification = true;
            self.update();
        }

        self.closeAddedLessonStepNotificationClick = function(e){
            self.showAddedLessonStepNotification = false;
            self.update();
        }

        self.saveSelectedLessonStepClick = function(e) {

            if (self.selectedStepToEdit && self.selectedStepToEdit.type === 'quiz') {
                var pendingSelectedQuestion = document.getElementById('selectedStepQuestion');
                if (pendingSelectedQuestion && pendingSelectedQuestion.value.trim()) {
                    self.addSelectedStepQuestionClick({});
                }
            }

            var selectedStep = self.lessonSteps.splice(self.selectedNewStep, 1)[0];
            selectedStep.title = document.getElementById("selectedStepTitle").value;
            selectedStep.directions = document.getElementById("selectedStepDirections").value;
            if (document.getElementById("selectedStepImage").value) {
                selectedStep.image = document.getElementById("selectedStepImage").value;
            }
            var newOrder = self.selectedNewStep;
            if (self.selectedStepToEdit.type === 'task') {

                var measureSel = document.getElementById("selectedStepMeasureToggle");
                var selectedStepMeasure = measureSel.options[measureSel.selectedIndex].value;

                selectedStep.sensor = self.convertBetweenSensorNameAndPrettyName(selectedStepMeasure, false);
            }

            self.lessonSteps.splice(newOrder, 0, selectedStep)

            self.selectedNewStep = -1;
            self.update();
        }

        self.deleteSelectedLessonStepClick = function(e) {
            self.lessonSteps.splice(self.selectedNewStep, 1);

            self.selectedNewStep = -1;
            self.update();
        }

        self.updateMCAnswerFromInput = function(e) {
            var idx = parseInt(e.target.getAttribute('data-idx'), 10);
            updateMCAnswer(idx, e.target.value);
        };
        self.removeMCAnswerFromButton = function(e) {
            var idx = parseInt(e.target.getAttribute('data-idx'), 10);
            removeMCAnswer(idx);
        };

        function getSensors() {

            const cached = localStorage.getItem("sensors");
            if (cached) {
                try {
                    self.sensorOptions = JSON.parse(cached);
                    self.update();
                    return;
                } catch (e) {
                    console.error("Failed to parse cached sensors:", e);
                }
            }

            libGetSensors().then(function(data) {
                if (data && data.data && Array.isArray(data.data.sensors)) {
                    self.sensorOptions = data.data.sensors;
                    localStorage.setItem("sensors", JSON.stringify(data.data.sensors));
                    self.update();
                }
            }).catch(function(err) {
                console.error('Failed to fetch sensors:', err);
            });
        }

        function postLesson(data) {
            self.submitLessonLoading = true;
            self.update();

            libPostLesson(data).then(function(res) {

                var savedLesson = (res && res['data']) ? (res['data']['lesson'] || res['data']['project']) : undefined;
                var lessonId = savedLesson ? savedLesson.id : undefined;
                return postQuestions(lessonId, self.lessonSteps);
            }).then(function() {
                self.submitLessonLoading = false;
                self.update({
                    lessonsMessage: "Successfully created " + self.opts.build_type + "!",
                    lessonsError: undefined
                });
            }).catch(function(error) {
                self.submitLessonLoading = false;
                console.error('POST Lessons Error:' + error);
                self.update({
                    lessonsError: error
                });
            });
        }

        function putLesson(data) {
            self.submitLessonLoading = true;
            self.update();

            libPutLesson(data).then(function(res) {

                var lessonId = (self.opts.lesson_to_edit) ? self.opts.lesson_to_edit.id : undefined;
                return postQuestions(lessonId, self.lessonSteps);
            }).then(function() {
                self.submitLessonLoading = false;
                self.update({
                    lessonsMessage: "Successfully updated " + self.opts.build_type + "!",
                    lessonsError: undefined
                });
            }).catch(function(error) {
                self.submitLessonLoading = false;
                console.error('PUT Lessons Error:' + error);
                self.update({
                    lessonsError: error
                });
            });
        }

        function collectQuestionsFromSteps(lessonId, steps) {
            var questions = [];
            if (!Array.isArray(steps)) return questions;
            for (var i = 0; i < steps.length; i++) {
                var step = steps[i];
                if (step.type === 'quiz' && Array.isArray(step.questions)) {
                    for (var j = 0; j < step.questions.length; j++) {
                        var q = step.questions[j];
                        if (!q || !q.question) continue;
                        var questionDoc = {
                            lesson_id: lessonId,
                            question: q.question,
                            type: q.type || 'fa',
                            activity_step: i
                        };

                        if (q.id !== undefined && q.id !== null && String(q.id).trim() !== '') {
                            questionDoc.id = q.id;
                        }
                        if (q.type === 'mc' && Array.isArray(q.options)) {
                            questionDoc.options = q.options;
                        }
                        questions.push(questionDoc);
                    }
                }
            }
            return questions;
        }

        function postQuestions(lessonId, lessonSteps) {
            var questions = collectQuestionsFromSteps(lessonId, lessonSteps);
            if (!lessonId || questions.length === 0) {
                console.log('No questions to save (or no lesson ID). Skipping POSTQuestions.');
                return Promise.resolve();
            }

            return libPostQuestion({
                lesson_id: lessonId,
                replace: true,
                questions: questions
            }).then(function(res) {
                var saved = res && res['data'] && res['data']['questions'] ? res['data']['questions'].length : 0;
                console.log('POSTQuestions: saved ' + saved + ' question(s) for lesson ' + lessonId);
            }).catch(function(err) {

                console.error('POSTQuestions error (non-fatal):', err);
            });
        }

});